import React from 'react';

// project-imports
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import TestimonialSectionReactJs from '../../components/testimonial-section/TestimonialSectionReactJs';

const Testimonial = () => {

    return (
        <>
            {pageView(window.location.pathname, GoogleAnalyticsEnum.TESTIMONIAL)}

            <SEO title="Longswitch Academy Students Testimonial" url={process.env.PUBLIC_URL + '/testimonial'} /> {/* Set SEO title */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Testimonial" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.ALL_TESTIMONIALS_TO_HOME}
                    currentUrl="Testimonial"
                />

                <div className="eduvibe-home-two-testimonial edu-testimonial-area testimonial-card-box-bg bg-image">
                    {/* Testimonial component */}
                    <TestimonialSectionReactJs courseDomain="All" />
                </div>

            </Layout>

        </>
    )
}

export default Testimonial;